// import { products } from '__common/constants/products';
import { isMetricUnit } from 'engineering/components/engineeringProjectDocuments/utils/unitTypes';
import { isSMAscenderFlush, isSolarMount, isSMTiltPRWithAscender } from '__common/constants/products';
import { state } from '__common/store';

const products = {
  solarmount_hd: 2,
  rm: 8,
  solarmount_2: 9,
  // adjustable_tilt_system: 99,
  solarmount_2_tilt: 99,
  sunframe: 5,
  solarmount_lt: 11,
  sfmEnhanced: 17, // sunframe microrail
  sfm_enhanced: 17,
  sfmInfinity: 18,
  sfm_infinity: 18,
  rm_5: 14,
  rm_dt: 15,
  gft: 19,
  ula: 20,
  rm_10_ultra: 21,
  helioscope: 98,
  rm_gridflex: 22,
  metal_x: 23,
  ecofoot2_plus: 24,
  nxt_umount : 25,
  nxt_horizon_lt : 26,
  nxt_horizon_hd : 27,
  rm_10_evolution: 28,
  ascender: 29,
  sm_tilt_pr : 30,
  sm_tilt_pr_lt : 31,
  solarmount_ascender_flush: 32,
  rm_gridflex_10d: 33,
  nxt_tilt: 34,
  sm_tilt_pr_ascender_rail: 35,
  rm_gridflex_5d: 36,
};

function accessibleProductForUser(paramProductName:string=undefined){
  const { user: { products: userProducts } } = state();
  return userProducts.includes(products[paramProductName]);
}
export default accessibleProductForUser;


export const isSMFlushMetric = () => {
  const { projectConfiguration: { railsProductId, inputUnit } } = state();
  return isSolarMount(railsProductId) && isMetricUnit(inputUnit);
};

export const isSMFamilyNonAscenderFlushMetric = () => {
  const { projectConfiguration: { railsProductId, inputUnit } } = state();
  return isSolarMount(railsProductId) &&  !isSMAscenderFlush(railsProductId) && isMetricUnit(inputUnit);
};

export const isSMAscenderFlushMetric = () => {
  const { projectConfiguration: { railsProductId, inputUnit } } = state();
  return isSMAscenderFlush(railsProductId) && isMetricUnit(inputUnit);
}

export const isSMTiltPrWithAscenderMetric = () => {
  const {projectConfiguration: {railsProductId, inputUnit}} = state();
  return isSMTiltPRWithAscender(railsProductId) && isMetricUnit(inputUnit);
};
